import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './InspectionMethod.css';
import { Box, Grid, Card, CardContent, Typography, Button } from '@mui/material';
import StepIndicator from './StepIndicatorMethod';
import { useSelector, useDispatch } from 'react-redux';
import { setLoading } from '../../store/feedback';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  Tooltip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Support from '../../contact-popup-module/Support';
import moment from 'moment';
import ShareAuditOptions from './ShareAuditOptions';
import { set_audit_modes } from '../../store/images';
import InternetSignal from '../../camera-module/internet-strength/InternetSignal';
const InspectionMethod = () => {
  const share = `${process.env.PUBLIC_URL}/custom-icons/share.svg`;
  const right_arrow = `${process.env.PUBLIC_URL}/custom-icons/right-arrow.png`;
  const copy = `${process.env.PUBLIC_URL}/custom-icons/pink-copy-icon.png`;
  const [dialogWidth, setDialogWidth] = useState('29vw');
  const [speed, setSpeed] = useState(null);
  const { audit_id } = useParams();
  const [reqUrl, setReqUrl] = useState(null);
  const [dialogSeverity, setDialogSeverity] = useState('success');
  const [isCopied, setIsCopied] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const query_icon = `${process.env.PUBLIC_URL}/custom-icons/query.png`;
  const arrow_icon = `${process.env.PUBLIC_URL}/custom-icons/arrow-next.png`;
  const clock_icon = `${process.env.PUBLIC_URL}/custom-icons/clock.png`;
  const uid = useSelector((state) => state.imagesStore.user_userID);
  console.log("38", uid);
  const navigate = useNavigate();
  const {
    auditModes,

  } = useSelector((state) => state.imagesStore);

  // State to check if the current time is between 10 am and 6 pm
  const [isAvailable, setIsAvailable] = useState(false);
  const dispatch = useDispatch();
  const showAlert = (severity, message) => {
    setDialogSeverity(severity);
    setOpenDialog(true);
  };
  const handleDialogClose = event => {
    // if (
    //   event.target.tagName.toLowerCase() !== "button" &&
    //   !event.target.closest("button")
    // ) {

    //   return;
    // }
    setOpenDialog(false);
  };
  const testSpeed = async () => {

    const fileSize = 5 * 1024 * 1024; // 5MB file
    const testFile = 'https://speed.cloudflare.com/__down?bytes=5000000'; // Cloudflare test file

    const startTime = new Date().getTime();

    try {
      const response = await fetch(testFile);
      await response.arrayBuffer();

      const endTime = new Date().getTime();
      const durationInSeconds = (endTime - startTime) / 1000;
      const speedMbps = (fileSize / durationInSeconds / (1024 * 1024) * 8).toFixed(2);
      console.log("speedMbps", speedMbps);

      setSpeed(speedMbps);
    } catch (error) {
      console.error('Speed test failed:', error);
      setSpeed('Error');
    }
  };
  useEffect(() => {
    const intervalId = setInterval(testSpeed, 2000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  const network = `${process.env.PUBLIC_URL}/custom-icons/network.png`;
  const [dialogText, setDialogText] = useState('0.9rem');
  const [openDialogLowInternet, setOpenDialogLowInternet] = useState(true);
  const handleDialogCloseLowInternet = event => {
    // console.log("called")
    setOpenDialogLowInternet(false);
  };

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth;
      if (windowWidth <= 450) {
        setDialogWidth('94vw');
      } else if (windowWidth <= 475) {
        setDialogWidth('94vw');
      } else if (windowWidth <= 570) {
      } else if (windowWidth <= 575) {
        setDialogText('0.6rem');
        setDialogWidth('64vw');
      } else if (windowWidth <= 650) {
        setDialogWidth('60vw');
      } else if (windowWidth <= 700) {
      } else if (window.innerWidth <= 775) {
        setDialogWidth('57vw');
      } else if (window.innerWidth <= 875) {
        setDialogWidth('55vw');
      } else if (windowWidth <= 1000) {
        setDialogWidth('48vw');
      } else if (window.innerWidth <= 1100) {
        setDialogWidth('45vw');
        setDialogText('0.8rem');
      } else if (windowWidth <= 1300) {
        setDialogWidth('40vw');
      } else {
        setDialogWidth('35vw');
      }
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    // Cleanup function to remove event listener
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const [allowedModes, setAllowedModes] = useState([]);
  console.log(auditModes);
  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await axios.get(`/create_audit/get_audit_details/${audit_id}`);
        console.log("200", response.data);

        const config = response.data?.inspection_config;
        if (config?.selectedMode?.length > 0) {
          // Store only selected modes from config
          setAllowedModes(config.selectedMode);
          console.log(allowedModes);

        }
      } catch (error) {
        console.error("Error fetching audit details:", error);
      }
    };

    if (audit_id) {
      fetchDetails();
    }
  }, [audit_id]);

  const cardContent = {
    video: {
      title: 'video',
      description: 'Record video of your vehicle for self-inspection.',
      isAvailable: false, //!isAvailable,
    },
    photo: {
      title: 'photo',
      description: 'Take photos of your vehicle for self-inspection.',
      isAvailable: false,
    },
    hybrid: {
      title: 'hybrid',
      description: 'Take photo & video of your vehicle for self-inspection.',
      isAvailable: false,
    },
  };

  useEffect(() => {
    const checkAvailability = () => {
      const currentHour = new Date().getHours();
      setIsAvailable(currentHour >= 6 && currentHour < 20);
    };

    checkAvailability();
    // Optionally, add a timer to check time every minute if needed
    const timer = setInterval(checkAvailability, 60000);
    return () => clearInterval(timer);
  }, []);

  const handleNavigate = url => {
    window.location.href = url;
  };
  const [selectedMethod, setSelectedMethod] = useState(null);

  const handleCardClick = method => {
    // console.log(method);
    setSelectedMethod(method);
    // You can also open a dialog or do other actions here
    // setOpenDialog(true);
  };

  const handleCombinedClick = async method => {
    // console.log(method, '186');
    setSelectedMethod(method);
    try {
      const res = await axios.post('/create_audit/add_mode', {
        audit: audit_id,
        mode: method,
      });
      const hostname = window.location.hostname;
      const port = window.location.port;
      let baseURL;
      if (port !== '') {
        baseURL = `https://${hostname}:${port}`;
      } else {
        baseURL = `https://${hostname}`;
      }
      const url = `${baseURL}/audit/${method}/permission/${audit_id}`;
      // console.log(url, '196');
      handleNavigate(url);
    } catch (err) {
      console.log(err, 'error');
    }
  };

  const renderCard = (title, description, disabled, method) => (
    <Card
      sx={{
        minHeight: '140px', // Allow the card to grow vertically
        mb: 2,
        borderRadius: 1,
        boxShadow: 2,
        border: '1px solid #e0e0e0',
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
        position: 'relative',
      }}
    >
      <CardContent
        sx={{
          padding: '5px',
          margin: '0.1rem',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between', // Ensure button stays at the bottom
          height: '100%', // Make content fill the card
        }}
      >
        <Grid container alignItems="center" marginTop="6px">
          <Grid item xs={8}>
            <Typography
              variant="h6"
              fontWeight="bold"
              fontFamily="Montserrat, sans-serif"
              sx={{
                fontSize: '15px',
                mb: 0,
                textTransform: 'capitalize',
              }}
            >
              {title} Mode
            </Typography>
          </Grid>
          <Grid item xs={4} sx={{ textAlign: 'right' }}>
            <img
              src={clock_icon}
              alt="clock icon"
              style={{
                width: '14px',
                height: '14px',
                verticalAlign: 'middle',
                marginRight: '3px',
                color: '#999999',
              }}
            />
            <Typography
              variant="caption"
              color="textSecondary"
              fontFamily="Montserrat, sans-serif"
              sx={{ fontSize: '12px' }}
            >
              Approx. 10m
            </Typography>
          </Grid>
        </Grid>

        <Typography
          variant="body2"
          color="textSecondary"
          fontFamily="Montserrat, sans-serif"
          sx={{
            mt: 0.8,
            mb: 0.8,
            lineHeight: 1.3,
            fontSize: '13px',
          }}
        >
          {description}
        </Typography>

        {disabled && (
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: '#333',
              color: '#fff',
              borderRadius: '12px',
              padding: '4px 12px',
              fontSize: '12px',
              fontFamily: 'Montserrat, sans-serif',
              zIndex: 10,
              textAlign: 'center',
            }}
          >
            Available 6am - 8pm
          </Box>
        )}

        <Box
          mt={1.5}
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            paddingBottom: '4px',
          }}
        >
          <button
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.2rem',
              padding: '0.3rem 0.8rem',
              backgroundColor: '#FF0083',
              borderRadius: '5px',
              maxWidth: '150px',
              cursor: 'pointer',
              border: 'none',
            }}
            onClick={() => handleCombinedClick(method)}
          >
            <span
              style={{
                fontSize: '1rem',
                fontFamily: "'Montserrat', sans-serif",
                color: 'white',
              }}
            >
              Choose
            </span>
            <img
              src={right_arrow}
              style={{ width: '0.5rem', height: '0.8rem' }}
              alt="Share Icon"
            />
          </button>
        </Box>
      </CardContent>
    </Card>

  );
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div style={{
      maxWidth: "600px",
      width: "100%",
      margin: '0px auto',
      position: "relative",
      height: "100svh"
    }}>
      {speed !== null && <InternetSignal signalStrength={speed} />}
      <img
        src={query_icon}
        alt="Query Icon"
        className="question-div"
        onClick={handleClickOpen}
      />

      {/* Support Popup */}
      <Dialog open={open} onClose={handleClose} className="support-popup-dialog">
        <DialogContent className="support-popup-content">
          <Support />
          <button onClick={handleClose} className="close-btn">close</button>
        </DialogContent>
      </Dialog>

      <Box sx={{ p: 3, maxWidth: 400, mx: 'auto', mt: '10px', height: "100vh" }}>
        <StepIndicator stepNumber={1} lineWidth="200px" />
        <Typography
          variant="h6"
          fontWeight="bold"
          align="center"
          fontFamily="Montserrat, sans-serif"
          sx={{ mb: 0, fontSize: '14px', color: '#000000DE' }}
        >
          Select method
        </Typography>

        <Typography
          variant="h4"
          fontWeight="600"
          align="center"
          fontFamily="Barlow Condensed"
          textAlign={'center'}
          sx={{ mb: 0.8, mt: 0.8, fontSize: '1.4rem', color: '#000000DE' }}
        >
          Choose the self-inspection method to proceed
        </Typography>

        <div>
          {auditModes?.map(mode => (
            <div key={mode}>
              {renderCard(
                cardContent[mode].title,
                cardContent[mode].description,
                cardContent[mode].isAvailable,
                mode
              )}
            </div>
          ))}
        </div>

      </Box>
      {speed && speed < 5 && <Dialog
        open={openDialogLowInternet}
        onClose={handleDialogCloseLowInternet}
        maxWidth="150vw"
        maxHeight="lg"
        PaperProps={{
          style: {
            width: dialogWidth,
            // padding: "1.5rem 1rem",
            // paddingBottom: "0.5rem",
            borderRadius: "4px",
            margin: "0px",
            height: "120px",
            zIndex: "999999"
          },
        }}
      >
        <DialogTitle
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",

            gap: "0.3rem",
            fontSize: "1.3rem",
            textAlign: "center",
            color: "black",
            padding: "1rem 0.9rem",
            fontWeight: "600",
            fontFamily: 'Barlow Condensed',
          }}
        >
          <>
            <img src={network} style={{ width: "9%" }} />
            <span >Low internet connection</span>
          </>
        </DialogTitle>
        <div style={{ padding: "0 1rem", fontFamily: "'Montserrat', sans-serif", }} >
          Please switch to a more stable connection to continue seamlessly
        </div>
        <IconButton
          aria-label="close"
          onClick={handleDialogCloseLowInternet}
          sx={{
            position: "absolute",
            right: 7,
            top: 10,
            color: "black",
          }}
        >
          <CloseIcon />
        </IconButton>
      </Dialog>}
    </div>
  );
};

export default InspectionMethod;
